var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnumeratorRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20C28.4183 20 32 16.4183 32 12C32 7.58172 28.4183 4 24 4C19.5817 4 16 7.58172 16 12C16 16.4183 19.5817 20 24 20Z",
    fill: "#64B5F6",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 44C42 34.0589 33.9411 26 24 26C14.0589 26 6 34.0589 6 44",
    stroke: "#616161",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44L28 39L24 26L20 39L24 44Z",
    fill: "#2F88FF",
    stroke: "#37474F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0058 14.0338C27.6669 12.9287 27.8302 11.5781 27.4045 10.3238C26.9787 9.06946 26.0271 8.09726 24.8299 7.62285C24.581 7.5001 24.2716 7.65693 24.1953 7.89005C24.0725 8.13895 24.2294 8.44838 24.4625 8.52468C25.4265 8.92279 26.1442 9.66355 26.4753 10.6391C26.8065 11.6147 26.6879 12.6393 26.1654 13.542C26.104 13.6664 26.0584 13.8373 26.1057 13.9767C26.1372 14.0696 26.231 14.1932 26.2932 14.2239C26.5421 14.3466 26.8673 14.2363 27.0058 14.0338Z",
    fill: "#BBDEFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnumeratorRole);
export default __webpack_public_path__ + "static/media/enumerator-role.725ca10813724969afb6711fbcb7dd25.svg";
export { ForwardRef as ReactComponent };